// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1cj6T","footer":"Form_footer__21bJP"};